class ProductFitment extends HTMLElement {
    connectedCallback() {
      this.changeDetails = this.querySelector('[data-fitment-change]');
  
      this.addEventListener('click', this.handleSectionToggle);
      document.addEventListener('click', this.closeChangeOnOutsideClick);
      document.addEventListener('keydown', this.closeChangeOnEscape);
    }
  
    disconnectedCallback() {
      document.removeEventListener('click', this.closeChangeOnOutsideClick);
      document.removeEventListener('keydown', this.closeChangeOnEscape);
    }
  
    // Show all / show less
    handleSectionToggle = (event) => {
      const toggleButton = event.target.closest('[data-fitment-toggle]');
      if (!toggleButton) return;
  
      const section = toggleButton.closest('[data-fitment-section]');
      const isExpanded = section.classList.toggle('is-expanded');
      const { labelMore, labelLess } = toggleButton.dataset;
  
      toggleButton.setAttribute('aria-expanded', String(isExpanded));
      toggleButton.querySelector('[data-fitment-toggle-label]').textContent = isExpanded ? labelLess : labelMore;
    };
  
    // Change vehicle dropdown
    closeChangeOnOutsideClick = (event) => {
      if (this.changeDetails?.open && !this.changeDetails.contains(event.target)) {
        this.changeDetails.open = false;
      }
    };
  
    closeChangeOnEscape = (event) => {
      if (event.key !== 'Escape' || !this.changeDetails?.open) return;
      this.changeDetails.open = false;
      this.changeDetails.querySelector('summary')?.focus();
    };
  }
  
  if (!customElements.get('product-fitment')) {
    customElements.define('product-fitment', ProductFitment);
  }